<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/FacultyMaster.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                     <h3 class="main-content-label mb-1"><b>
                                                        Practical Examiner Assignment Data
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        Practical Examiner Assignment 
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4" >
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Search
                                                </mat-label> 
                                                <input class="color" matInput placeholder="Search">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-2 prpl">
                                            <button id="New" type="button" (click)="addnewrecord()"
                                                class="btn btn-primary btn-icon-text  mt-1">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 7px;">
                                                   New
                                                </span>
                                            </button>

                                            <!-- <button id="Report" type="button" (click)="print()"
                                                class="btn btn-primary btn-icon-text  mt-1">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/printer.gif"
                                                        style="margin-right: 7px;">
                                                   Final Report
                                                </span>
                                            </button> -->
                                        </div>
                                        
                                    </div>
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Session
                                                    </th>
                                                    <th class="f600 ">
                                                       Examiner Name
                                                    </th>
                                                    <th class="f600">
                                                        Designation
                                                    </th>
                                                    <!-- <th width="10%" class="f600 text-center">
                                                      Action
                                                    </th> -->
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                 <tr *ngFor="let Examiner of ExaminerList;">
                                                     <td>{{Examiner.SnName}}</td>
                                                     <td>{{Examiner.Initial}} {{Examiner.FirstName}} {{Examiner.MiddleName}} {{Examiner.LastName}} </td>
                                                     <td>{{Examiner.Role}} </td>
                                                 </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" 
                                    [pageSizeOptions]="pageSizeOptions"
                                    (page)="onPageChange($event)"></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>